import React from "react";
import MediaCarousel from "./MediaCarousel.jsx";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  hideIntercom,
  showIntercom,
  getBrowserScrollbarWidth,
  deactivateScrollbar,
  reactivateScrollbar,
} from "../utils/Utils.js";
export default class CarouselModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      items: this.props.items,
      indexToFocus: 0,
    };
    const scrollbarWidth = getBrowserScrollbarWidth();
    this.openModal = () => {
      hideIntercom();
      deactivateScrollbar(scrollbarWidth);
      this.setState({
        open: true,
      });
    };

    this.closeModal = () => {
      showIntercom();
      reactivateScrollbar();
      this.setState({
        open: false,
      });
    };
  }

  focusIndex = (i) => {
    if (i != undefined && i != null && i >= 0) {
      this.setState({
        indexToFocus: i,
      });
    }
  };

  handleOpen = () => this.openModal();
  handleClose = () => this.closeModal();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setState({
        items: this.props.items,
      });
    }
  }

  render() {
    return (
      <Dialog
        fullScreen={true}
        open={this.state.open}
        onClose={this.closeModal}
        aria-labelledby="Media gallery"
        aria-describedby="Media gallery carousel"
      >
        <DialogTitle className="r_galleryTitle">
          <div className="r_dialogTitle">
            <div className="r_dialogTitleText">
              {playdetailsv2_resources.Gallery}
            </div>
            <CloseIcon
              onClick={this.closeModal}
              className="r_dialogTitleIcon"
            />
          </div>
        </DialogTitle>
        <DialogContent>
          <MediaCarousel
            goTo={this.state.indexToFocus}
            media={this.state.items}
          />
        </DialogContent>
      </Dialog>
    );
  }
}
